module.exports = __webpack_public_path__ + "static/img/chuju.224eee4.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/chuju.png
// module id = Wtae
// module chunks = 0